import './js-forms.css';

export const formDataToObject = async function (form) {
	const fields = form.querySelectorAll('input, select, textarea');
	const output = {};

	for (let i = 0, imax = fields.length; i < imax; ++i) {
		const field = fields[i];
		const sKey = field.name || field.id;

		if (field.type === 'button' || field.type === 'image' || field.type === 'submit' || !sKey) {
			continue;
		}

		switch (field.type) {
			case 'checkbox':
				if (!field.checked) {
					break;
				}

				if (form.querySelectorAll(`input[name="${field.name}"]`).length < 2) {
					output[sKey] = field.value;
					break;
				}

				if (typeof output[sKey] === 'undefined') {
					output[sKey] = [];
				}

				output[sKey].push(field.value);

				break;
			case 'radio':
				if (typeof output[sKey] === 'undefined') {
					output[sKey] = '';
				}

				if (field.checked) {
					output[sKey] = field.value;
				}
				break;
			case 'select-multiple':
				const entries = [];
				for (let j = 0, jmax = field.options.length; j < jmax; ++j) {
					if (field.options[j].selected) {
						entries.push(field.options[j].value);
					}
				}

				output[sKey] = entries;
				break;
			case 'file':
				const selectedFiles = field.files;

				if (selectedFiles && selectedFiles.length === 0) {
					output[sKey] = null;

					continue;
				}

				if (sKey.endsWith('[]')) {
					if (!output[sKey]) {
						output[sKey] = {};
					}

					let startIndex = Object.keys(output[sKey]).length;

					for (let j = 0; j < selectedFiles.length; j++) {
						output[sKey][(startIndex + j).toString()] = await readFileAsync(selectedFiles[j]);
					}

					continue;
				} else if (selectedFiles.length === 1) {
					output[sKey] = await readFileAsync(selectedFiles[0]);

					continue;
				}

				output[sKey] = null;

				break;
			default:
				output[sKey] = field.value;
		}
	}

	return output;
};

const readFileAsync = async (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();

		reader.onload = () => resolve(reader.result);

		reader.onerror = () => reject(new Error('File reading failed'));

		reader.readAsDataURL(file);
	});
};

const submitForm = (url, data) => {
	const xhr = new XMLHttpRequest();

	xhr.open('POST', url);
	xhr.responseType = 'json';
	xhr.setRequestHeader('Accept', 'application/json');
	xhr.setRequestHeader('Content-Type', 'application/json');

	return new Promise((resolve) => {
		xhr.onreadystatechange = () => {
			if (xhr.readyState === XMLHttpRequest.DONE) {
				resolve(xhr);
			}
		};

		xhr.send(JSON.stringify(data));
	});
};

const handleJsForms = () => {
	document.querySelectorAll('.coredna-js-form').forEach(handleJsForm);
};

const handleJsForm = (formContainer) => {
	const formIdField = formContainer.querySelector('input[name="_formId"]');

	if (!formIdField) {
		console.error('_formId input is required');
		return;
	}

	const getCallback = (dataFieldName) => {
		const callbackName = formContainer.dataset[dataFieldName] || null;

		if (!callbackName) {
			return null;
		}

		return typeof window[callbackName] === 'function' ? window[callbackName] : null;
	};

	const formId = formIdField.value;
	const steps = Array.from(formContainer.querySelectorAll('.form-step'));
	const forms = Array.from(formContainer.querySelectorAll('.form-step form'));
	const elements = Array.from(formContainer.querySelectorAll('input, select, textarea'));
	const lastStep = steps[steps.length - 1];
	const lastForm = forms[forms.length - 1];
	const redirectUrl = formContainer.querySelector('input[name="_redirectUrl"]');
	const endpoint = (formContainer.dataset.endpoint || '/cdna-api/forms/submission/FORM_ID').replace(
		'FORM_ID',
		formId,
	);
	let formStarted = false;

	let currentStep = steps[0];

	// `startCallback` is read eagerly because it gates whether we install
	// keyup/change listeners at all — no point installing them on a form that
	// never defines a start callback.
	const formStartedCallback = getCallback('startCallback');

	// The remaining callbacks are read lazily at the moment they're invoked,
	// so that scripts loaded after this file (e.g. js-payment-element.js, which
	// rewrites `data-submit-modifier-callback` / `data-submit-result-callback`
	// on forms containing a payment element) take effect.
	const getNavigateCallback = () => getCallback('navigateCallback');
	const getSubmitModifierCallback = () => getCallback('submitModifierCallback');
	const getSubmitCallback = () => getCallback('submitCallback');
	const getSubmitResultCallback = () => getCallback('submitResultCallback');

	// Guards against duplicate `submit` events on the final step (Safari can
	// dispatch a second event while the first is still in its async chain).
	// Disabling the submit buttons is not enough: a second already-dispatched
	// event still re-enters the handler and would tokenize the payment and
	// POST the submission twice — the duplicate then fails reCAPTCHA
	// validation, because the token is single-use.
	let isSubmitting = false;

	const handleSubmitError = (response) => {
		// Allow the user to retry after a failed submission
		isSubmitting = false;

		// Enable the submit button(s)
		const submitButtons = currentStep.querySelectorAll('button[type="submit"], input[type="submit"]');
		submitButtons.forEach((button) => {
			button.removeAttribute('disabled');
		});
		// Show the error message(s)
		const currentStepErrorMessages = currentStep.querySelectorAll('.submit-error-message');
		currentStepErrorMessages.forEach((messageContainer) => {
			messageContainer.classList.remove('js-hidden');

			if (!response.message) {
				return;
			}

			if (response.validationErrors) {
				const errors = response.validationErrors;
				for (let key in errors) {
					errors[key].forEach((error) => {
						if (error.message) {
							steps.forEach((step) => {
								const foundElement = step.querySelector(`[name="${key}"]`);

								if (!foundElement) {
									return;
								}

								const formFieldWrapper = foundElement.closest(
									'.base-element-block.input-element-block',
								);

								if (formFieldWrapper) {
									formFieldWrapper.innerHTML += `<div class="input-element-validation-errors">${error.message}</div>`;
								}
							});
						}
					});
				}
			}

			// Assign the original HTML to the dataset, or assign it from the dataset to the message if it already exists
			typeof messageContainer.dataset.originalHtml === 'undefined'
				? (messageContainer.dataset.originalHtml = messageContainer.innerHTML)
				: (messageContainer.innerHTML = messageContainer.dataset.originalHtml);

			// Assign the response message, or replace a message placeholder in the HTML
			messageContainer.dataset.originalHtml.indexOf('%message%') === -1
				? (messageContainer.innerHTML = response.message)
				: (messageContainer.innerHTML = messageContainer.dataset.originalHtml.replace(
						/%message%/,
						response.message,
					));
		});
	};

	const handleSubmitInProgress = () => {
		// Hide the error message(s)
		const currentStepErrorMessages = currentStep.querySelectorAll('.submit-error-message');
		currentStepErrorMessages.forEach((container) => {
			container.classList.add('js-hidden');
		});

		// Disable the submit button(s)
		const submitButtons = currentStep.querySelectorAll('button[type="submit"], input[type="submit"]');
		submitButtons.forEach((button) => {
			button.setAttribute('disabled', 'disabled');
		});
	};

	const handleResponse = (xhr, form) => {
		if (xhr.status >= 199 && xhr.status < 300 && xhr.status !== 207) {
			if (redirectUrl) {
				window.location.replace(redirectUrl.value);

				return;
			}
			navigateToStep(lastStep);

			return;
		}

		if (xhr.response) {
			const jsonResponse = JSON.parse(xhr.response);

			handleSubmitError(
				typeof jsonResponse === 'object' && typeof jsonResponse.message === 'string' ? jsonResponse : '',
				form,
			);
		}
	};

	const getAllFormData = async () => {
		const allFormData = {};
		const formDataPromises = forms.map((form) => formDataToObject(form));
		const formDataArray = await Promise.all(formDataPromises);

		formDataArray.forEach((formData) => {
			Object.assign(allFormData, formData);
		});

		return allFormData;
	};

	const compileCallbackData = (additionalData) => ({
		currentStepNumber: parseInt(currentStep.dataset.step),
		currentStep,
		formContainer,
		formId,
		...additionalData,
	});

	const navigateToStep = async (requestedStep) => {
		// Get the step numbers (assuming dataset.step is a 1-based string)
		const requestedStepNumber = parseInt(requestedStep.dataset.step);
		const currentStepNumber = parseInt(currentStep.dataset.step);

		// Determine the navigation direction
		const direction = requestedStepNumber > currentStepNumber ? 'forward' : 'backward';

		// Use a helper to get the first visible step in the desired direction
		const targetStep = getVisibleStep(requestedStep, direction);

		if (!targetStep) {
			console.warn('No visible step found in the ' + direction + ' direction.');
			return;
		}

		// Now, continue as before.
		const allFormData = await getAllFormData();

		const callbackData = compileCallbackData({
			data: allFormData,
			requestedStep: targetStep,
			requestedStepNumber: parseInt(targetStep.dataset.step),
		});

		const navigateCallback = getNavigateCallback();
		Promise.resolve(typeof navigateCallback === 'function' ? navigateCallback(callbackData) : true)
			.then((result) => {
				if (result === false) {
					return;
				}
				changedDisplayedStep(targetStep);
			})
			.catch((err) => {
				if (err) {
					console.error(err);
				}
			});
	};

	// Helper to find the first visible step starting from a given step in a given direction
	const getVisibleStep = (startStep, direction = 'forward') => {
		let step = startStep;

		while (step && step.getAttribute('data-skipped') === 'true') {
			step = direction === 'forward' ? step.nextElementSibling : step.previousElementSibling;
		}

		if (!step) {
			console.warn('No visible step found in the', direction, 'direction.');
		}

		return step;
	};

	const changedDisplayedStep = (requestedStep) => {
		currentStep.classList.add('js-hidden');
		requestedStep.classList.remove('js-hidden');

		currentStep = requestedStep;
	};

	const handleElementAction = (event) => {
		if (formStarted) {
			return;
		}

		if (formStartedCallback) {
			formStartedCallback(compileCallbackData({ event }));
		}

		formStarted = true;
	};

	// Handle form start if we have a callback for this
	if (formStartedCallback) {
		elements.forEach((element) => {
			element.addEventListener('keyup', handleElementAction);
			element.addEventListener('change', handleElementAction);
		});
	}

	// Handle navigation within the form steps
	steps.forEach((step, index) => {
		// Assign a step number to every step; this is 0-based
		step.dataset.step = (index + 1).toString();

		step.querySelectorAll('.navigate-previous').forEach((element) => {
			const requestedStepNr = index - 1;

			element.addEventListener('click', (event) => {
				event.preventDefault();

				if (typeof steps[requestedStepNr] === 'undefined') {
					console.error('Can not navigate to previous step, as no previous step exists');
					return;
				}

				navigateToStep(steps[requestedStepNr]);
			});
		});

		step.querySelectorAll('.go-to-step').forEach((element) => {
			if (!element.dataset.step) {
				console.error('Expected data-step with 1-based target step number on element', element);

				return;
			}

			const requestedStepNr = parseInt(element.dataset.step) - 1;

			element.addEventListener('click', (event) => {
				event.preventDefault();

				if (typeof steps[requestedStepNr] === 'undefined') {
					console.error(
						`Can not navigate to target step, as step with 1-based index ${element.dataset.step} does not exist`,
					);
					return;
				}

				navigateToStep(steps[requestedStepNr]);
			});
		});
	});

	// Handle submission of all non-final form steps
	forms.forEach((form) => {
		if (form === lastForm) {
			return;
		}

		form.addEventListener('submit', (event) => {
			const requestedStep = steps[parseInt(currentStep.dataset.step)]; // no need to add + 1, as dataset.step is 1-based

			event.preventDefault();

			// If we have a navigate callback and delivered a falsy result, don't navigate ourselves
			navigateToStep(requestedStep);
		});
	});

	// Handle submission of the last form => final submission to the endpoint
	lastForm.addEventListener('submit', async (event) => {
		event.preventDefault();

		if (isSubmitting) {
			return;
		}

		isSubmitting = true;

		handleSubmitInProgress();

		// Until the network submission is kicked off, this handler owns the `isSubmitting`
		// lock and the `finally` below releases it on every pre-network exit. Once the
		// request is in flight, `handleSubmitFormResult` owns the lock and releases it
		// when the request settles — so the duplicate-event window stays closed.
		let networkSubmitStarted = false;

		try {
			const allFormData = await getAllFormData();

			const submitModifierCallbackData = compileCallbackData({
				resultStepNumber: parseInt(lastStep.dataset.step),
				resultStep: lastStep,
				data: allFormData,
				event,
			});

			const submitModifierCallback = getSubmitModifierCallback();
			let modifiedFormData;
			try {
				modifiedFormData = await Promise.resolve(
					typeof submitModifierCallback === 'function'
						? submitModifierCallback(submitModifierCallbackData)
						: allFormData,
				);
			} catch (err) {
				console.error('Submit modifier error:', err);
				handleSubmitError({ message: err?.message || 'An error occurred. Please try again.' });

				return;
			}

			if (!modifiedFormData) {
				return;
			}

			const submitCallbackData = compileCallbackData({
				resultStepNumber: parseInt(lastStep.dataset.step),
				resultStep: lastStep,
				data: modifiedFormData,
				event,
			});

			const handleSubmitFormResult = (xhr) => {
				// The request has settled — the duplicate-event window has passed
				isSubmitting = false;

				const submitResultCallback = getSubmitResultCallback();
				if (typeof submitResultCallback !== 'function') {
					handleResponse(xhr, event.target);

					return;
				}

				const resultCallbackData = compileCallbackData({
					resultStepNumber: parseInt(lastStep.dataset.step),
					resultStep: lastStep,
					data: modifiedFormData,
					xhr,
				});

				Promise.resolve(submitResultCallback(resultCallbackData))
					.then((result) => {
						if (result) {
							handleResponse(xhr, event.target);
						}
					})
					.catch((err) => {
						if (err) {
							console.error(err);
						}
					});
			};

			const submitCallback = getSubmitCallback();
			let response;
			try {
				response = await Promise.resolve(
					typeof submitCallback === 'function' ? submitCallback(submitCallbackData) : true,
				);
			} catch (err) {
				if (err) {
					console.error(err);
				}

				return;
			}

			if (response === false) {
				// Submission cancelled by the callback — allow resubmitting
				return;
			}

			networkSubmitStarted = true;
			submitForm(endpoint, modifiedFormData).then(handleSubmitFormResult).catch(handleSubmitFormResult);
		} finally {
			if (!networkSubmitStarted) {
				isSubmitting = false;
			}
		}
	});
};

if (document.readyState !== 'loading') {
	handleJsForms();
} else {
	document.addEventListener('DOMContentLoaded', handleJsForms);
}
